<div #subList class="nav-sub-list" [class.sub-list-open]="viewModel.isNavListActive$ | async">
  @for (subItem of navItem?.subItems; track subItem?.name) {
    <app-nav-sub-item
      *rxIf="subItem | isDefaultNavSubItem"
      [navItem]="navItem"
      [subItem]="subItem"
      [currentNavUrl]="currentNavUrl" />
    <app-products-sub-nav-item
      *rxIf="subItem | isProductsNavSubItem"
      [navItem]="navItem"
      [subItem]="subItem"
      [currentNavUrl]="currentNavUrl" />
    <app-incomplete-sub-nav-item
      *rxIf="subItem | isIncompleteNavSubItem"
      [navItem]="navItem"
      [subItem]="subItem"
      [currentNavUrl]="currentNavUrl" />
  }
</div>
